export default (axios, walletId) => axios.post(`/wallet/change/${walletId}`);
